import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import useSWR from "swr";

import classNames from "classnames";

import { faEnvelope } from "@fortawesome/free-regular-svg-icons/faEnvelope";
import { faRss } from "@fortawesome/free-solid-svg-icons/faRss";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import { profileUrl } from "components/ProfilePageLayout";
import { baseFetcher } from "utils/baseFetcher";

import style from "./style.module.scss";

const FollowButton = dynamic(() => import("components/FollowButton"));
const MessageButton = dynamic(() => import("components/MessageButton"));

export const ProfileCardButtonsWithAuthentication = ({
  slug,
  subSlug,
  isCompany: propIsCompany,
  className,
  buttonClassName,
  buttonHoverClassName,
  buttonActiveClassName,
  defaultMessage,
  showIcon,
  alwaysShow,
  hideTextOnActive,
}: {
  slug: string;
  subSlug?: string;
  isCompany?: boolean;
  className?: string;
  buttonClassName?: string;
  buttonHoverClassName?: string;
  buttonActiveClassName?: string;
  defaultMessage?: string;
  showIcon?: boolean;
  alwaysShow?: boolean;
  hideTextOnActive?: boolean;
}) => {
  const router = useRouter();
  const isCompany =
    propIsCompany || router.route.startsWith("/companies/[slug]");
  const { data: profile, mutate } = useSWR(
    profileUrl(slug, isCompany),
    baseFetcher
  );
  const { data: subProfile } = useSWR(
    subSlug && profileUrl(subSlug),
    baseFetcher
  );

  return (
    <>
      <div
        className={classNames(
          "flex flex-row-reverse",
          "space-x-reverse space-x-[10px]",
          className
        )}
      >
        <MessageButton
          profile={subSlug ? subProfile : profile}
          className={buttonClassName}
          hoverClassName={buttonHoverClassName}
          defaultMessage={defaultMessage}
          showIcon={showIcon}
          alwaysShow={alwaysShow}
        />
        <FollowButton
          key={profile?.id} // force reload follow state
          profile={profile}
          className={buttonClassName}
          hoverClassName={buttonHoverClassName}
          activeClassName={buttonActiveClassName}
          showIcon={showIcon}
          alwaysShow={alwaysShow}
          hideTextOnActive={hideTextOnActive}
        />
      </div>
    </>
  );
};

const ProfileCardButtons = ({
  fullWidth,
  size,
  profile,
  subProfile,
}: {
  fullWidth?: boolean;
  size?: string;
  profile: any;
  subProfile?: any;
}) => {
  return (
    <div className={style.footer}>
      {profile.activated && (
        <div
          className={classNames(
            style.outline_btn_container,
            fullWidth && style.full_width,
            size && style[size],
            style.disabled
          )}
        >
          <button disabled>
            <FontAwesomeIcon icon={faRss} />
            Follow
          </button>
        </div>
      )}
      {(!profile.isCompany || subProfile) && (
        <div
          className={classNames(
            style.outline_btn_container,
            fullWidth && style.full_width,
            size && style[size],
            style.disabled
          )}
        >
          <button disabled>
            <FontAwesomeIcon icon={faEnvelope} />
            Message
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileCardButtons;
